"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigService = void 0;
class ConfigService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of countries
     * @returns Countries
     * @throws ApiError
     */
    getCountries() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config/countries',
        });
    }
    /**
     * Returns a list of countries for pricing
     * @returns Countries
     * @throws ApiError
     */
    getPricingCountries() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config/countries-pricing',
        });
    }
    /**
     * Returns a list of languages
     * @returns Languages
     * @throws ApiError
     */
    getLanguages() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config/languages',
        });
    }
    /**
     * Returns a list of time zones
     * @returns TimeZones
     * @throws ApiError
     */
    getTimeZones() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config/timezones',
        });
    }
    /**
     * Returns a list of types of deliverables
     * @returns Deliverables
     * @throws ApiError
     */
    getDeliverableTypes() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config/deliverables',
        });
    }
    /**
     * Returns a list of budget categories
     * @returns BudgetCategoriesResponse
     * @throws ApiError
     */
    getBudgetCategories() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config/budget/categories',
        });
    }
}
exports.ConfigService = ConfigService;
